<template>
    <div left class="d-flex align-items-center justify-content-end">
        <v-select
            @input="eventSelected"
            v-model="currentSite.id"
            placeholder="Filter By Site"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :reduce="(option) => option.id"
            :get-option-label="getOptionLabel"
            :options="sitesData.map(g => ({
                title: g.name[currentLocale], 
                id: g.id
            }))"
            :clearable="false"
            style="width: 200px;"
        />
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import store from '@/store'
    import { ref,onUnmounted, nextTick } from '@vue/composition-api'
    import sitesStoreModule from '@/views/sites/sitesStoreModule'
    

    export default {
        components: {
            vSelect
        },
        computed: {
            currentLocale(){
                return this.$i18n.locale;
            }
        },
        setup(props,{}){
            const currentSite = ref(null);

            let siteStorage = JSON.parse(localStorage.getItem('site'));
            currentSite.value = siteStorage;

            const SITE_STORE_MODULE_NAME = 'app-sites'
            if (!store.hasModule(SITE_STORE_MODULE_NAME)) store.registerModule(SITE_STORE_MODULE_NAME, sitesStoreModule)
            onUnmounted(() => {
                if (store.hasModule(SITE_STORE_MODULE_NAME)) store.unregisterModule(SITE_STORE_MODULE_NAME)
            });

            const sitesData = ref([])
            const site = ref({})
            
            const getData = async (status) => {
                let response =  await store.dispatch('app-sites/fetchSites', status);
                sitesData.value  = response.data.data
                if(currentSite.value == null){
                    currentSite.value  = response.data.data[0]
                    localStorage.setItem('site', JSON.stringify(response.data.data[0]))
                }
            }

            const eventSelected = (event) => {
                const id = event
                const findSite = sitesData.value.find(site => site.id === id)
                if (findSite) {
                    site.value = findSite
                    currentSite.value = site.value;
                    localStorage.setItem('site', JSON.stringify(site.value))
                }
                nextTick(() => {
                    
                    location.reload();
                });
               
            }

            const checkStatusSites = {
                is_active: 1
            }

            getData(checkStatusSites)

            return {
                sitesData,
                eventSelected,
                currentSite
            }
        }, 
        methods: {
            getOptionLabel(option) {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = option.title;
                return tempDiv.textContent || tempDiv.innerText || "";
            },
        },
    }
</script>